import * as ActionTypes from '../ActionTypes';

const initialState = {
    subscriptionData: [],
    isLoading: false,
};

const SubscriptionReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SUBSCRIPTION_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                subscriptionData: "",
            };
        case ActionTypes.SUBSCRIPTION_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                isLoading: false,
                subscriptionData: action.payload?.data?.data
            };
        case ActionTypes.SUBSCRIPTION_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.SUBSCRIPTION_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
                addSuccess: false,
            };
        case ActionTypes.SUBSCRIPTION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                addSuccess: true,
                successMessage: action.payload?.message,
                subscriptionData: action.payload?.data?.data,
            };
        case ActionTypes.SUBSCRIPTION_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                addSuccess: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message,
              
            };
        default:
            return state;
    }
}

export default SubscriptionReducer;